import React, { MouseEventHandler } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { createGlobalStyle, ThemeProvider } from 'styled-components';

import { keycloak, keycloakInitOptions } from './keycloak';
import store from './redux/store';
import './services/i18n.service';
import CentrifugoManagerHook from './hooks/CentrifugoManager.hook';
import ModalManagerHook from './hooks/ModalManager.hook';

import App from './views/App';
import defaultTheme from './constants/theme/default.theme';

import './index.css';

const GlobalStyles = createGlobalStyle`
  body {
    color: ${({ theme }: any) => theme.colors.TITLE};
  }
`;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={keycloakInitOptions}
  >
    <ThemeProvider theme={defaultTheme}>
      <Provider store={store}>
        <BrowserRouter>
          <ModalManagerHook>
            <CentrifugoManagerHook>
              <App />
            </CentrifugoManagerHook>
          </ModalManagerHook>
        </BrowserRouter>
        <GlobalStyles />
      </Provider>
    </ThemeProvider>
  </ReactKeycloakProvider>,
);
